
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4f319b61\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-loader/index.js??ref--9!../../../node_modules/string-replace-loader/index.js??ref--10!../../../node_modules/string-replace-loader/index.js??ref--11!../../../node_modules/string-replace-loader/index.js??ref--12!./Footer.vue")
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4f319b61\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!../../../node_modules/string-replace-loader/index.js??ref--9!../../../node_modules/string-replace-loader/index.js??ref--10!../../../node_modules/string-replace-loader/index.js??ref--11!../../../node_modules/string-replace-loader/index.js??ref--12!./Footer.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-loader/index.js??ref--9!../../../node_modules/string-replace-loader/index.js??ref--10!../../../node_modules/string-replace-loader/index.js??ref--11!../../../node_modules/string-replace-loader/index.js??ref--12!./Footer.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4f319b61\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-loader/index.js??ref--9!../../../node_modules/string-replace-loader/index.js??ref--10!../../../node_modules/string-replace-loader/index.js??ref--11!../../../node_modules/string-replace-loader/index.js??ref--12!./Footer.vue"),
  /* scopeId */
  "data-v-4f319b61",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/layout/Footer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Footer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4f319b61", Component.options)
  } else {
    hotAPI.reload("data-v-4f319b61", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/layout/Footer.vue
// module id = 963
// module chunks = 0